import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_ctx.modalShow)
    ? (_openBlock(), _createBlock(_component_v_dialog, {
        key: 0,
        modelValue: _ctx.modalShow,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalShow) = $event)),
        width: "800",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            ref: "form",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, {
            default: _withCtx(() => [
              (_ctx.scenario)
                ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { "primary-title": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.setScenarioName")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.setScenarioNameMessage")), 1),
                          _createVNode(_component_v_text_field, {
                            density: "compact",
                            modelValue: _ctx.scenario.name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.scenario.name) = $event)),
                            variant: "outlined",
                            label: _ctx.$t('message.scenarioName'),
                            rules: _ctx.nameRules
                          }, null, 8, ["modelValue", "label", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "text",
                            onClick: _ctx.save,
                            type: "submit"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.save")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}